import { useState } from "react";
import Box from "./layouts/Box";
import Flex from "./layouts/Flex";
import PropTypes from "prop-types";
import InfoSvg from "imagesUwKluis/svg/info.svg";
import AlertSvg from "imagesUwKluis/svg/alertfill.svg";
import OpenSvg from "imagesUwKluis/svg/open.svg";
import { useTheme } from '@emotion/react';
import { useMediaQuery } from "@dnhb/node_package";
import i18n from "../../i18n";

const DescriptionMessage = ({ title=i18n.t("Toelichting"), children, error=false, mb=0 }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { colors, breakpoints } = useTheme();
  const isMinTablet = useMediaQuery(
    `(min-width: ${breakpoints.md ?? "37.5rem"})`
  );
  const iconSize = isMinTablet ? "24px" : "18px";

  return (
    <Flex
      vGap="none"
      hGap="m"
      mb={mb}
      bg="white"
      css={theme => ({
        boxShadow: theme?.boxShadows?.large,
        cursor: "pointer"
      })}
      onClick={(e) => {
        if (e.target.tagName !== 'A') setIsOpen(val => !val)
      }}
      fontSize={{ mobile: "14px", tablet: "initial" }}
    >
      <Box bg={error ? "alertActive" : "primary"} width="4px" />
      <Flex
        flexDirection="column"
        p={{ mobile: "16px 12px 16px 16px", tablet: "12px 24px" }}
        width="100%"
      >
        <Flex alignItems="center" width="100%">
          <Flex alignItems="center" justifyContent="center" flexShrink="0">
            {error ? (
              <AlertSvg
                fill={colors.alertActive}
                width={iconSize}
                height={iconSize}
              />
            ) : (
              <InfoSvg
                fill={colors.primary}
                width={iconSize}
                height={iconSize}
              />
            )}
          </Flex>
          <Box flexGrow={1} m={{ mobile: "0 12px", tablet: "0 28px" }}>
            <Box fontWeight="bold">
              {title}
            </Box>
            {isMinTablet && isOpen && <Box mt="xs">{children}</Box>}
          </Box>
          <Flex alignItems="center" flexShrink="0">
            <OpenSvg
              width={isMinTablet ? "32px" : "24px"}
              fill={colors.secondaryButtonActive}
              css={{ transform: isOpen ? "rotate(-90deg)" : "rotate(90deg)" }}
            />
          </Flex>
        </Flex>
        {!isMinTablet && isOpen && <Box mt="12px">{children}</Box>}
      </Flex>
    </Flex>
  );
};

DescriptionMessage.propTypes = {
  title: PropTypes.string,
  error: PropTypes.bool,
  mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default DescriptionMessage;
